import { useNavigate, useParams } from 'react-router-dom'
import './storydetails.scss'
import { useCallback, useEffect, useMemo, useState, useRef } from 'react'
import { getArticleById, getTalentShowImages } from '../../../api/Category.service'
import { getHtml } from '../../../helper/utils'
import { Helmet } from 'react-helmet-async'
import Image from '../../../components/Image/Image'
import NoDataFound from '../../../components/NoDataFound/NoDataFound'
import Loader from '../../../components/Loader/Loader'
import { getTagList } from '../../../api/tags.service'
import CustomButton from '../../../components/Button/Button'
import { useMenuContext } from '../../../context/MenuContext'
import PageNotFound from '../../../components/PageNotFound/PageNotFound'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import PhotoCarousel from '../../../components/PhotoCarousel/PhotoCarousel'
import ReactDOM from 'react-dom'

const StoryDetails = () => {
  const categoryBlockRef = useRef<HTMLDivElement | null>(null);
  const breadcrumbContainerRef = useRef<HTMLDivElement>(document.createElement('div'));
  const { menu } = useMenuContext()

  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedTag, setSeletectedTag] = useState('')

  const [storyArticle, setStoryArticle] = useState<any>()
  const [status, setStatus] = useState<{ loading: boolean; error: string | null }>({
    loading: true,
    error: null,
  })

  useEffect(() => {
    window.scrollTo(0, 0) // Scroll to top when component mounts
  }, [id])

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const findCarousleValue = () => {
      const slider = document.getElementById("talent-show-carousel");
      if (slider) {
          const id = slider.getAttribute('id')
          const carouselId = slider.getAttribute('data-tag')
        
          if (carouselId && id) {
            const getData = async (carouselId: any) => {
              var targetElement = document.getElementById(id)
              const carouselImages: any = await getTalentShowImages(carouselId);
              const images = carouselImages?.data ?? [];
              if (images.length && targetElement) {
                images.sort((a: any, b: any) => Number(a.order) - Number(b.order));
                ReactDOM.render(
                  <div className='photo-carousel'>
                    <PhotoCarousel talentImages={images ?? []}/>
                  </div>
                ,
                targetElement,
                )
              }
            }
            getData(carouselId);
          } else {
            console.log(' Tag attribute not found on the element')
          }
      } else {
        timeoutId = setTimeout(findCarousleValue, 100)
      }
    }

    findCarousleValue()
    return () => {
      clearTimeout(timeoutId)
    }
  }, [id])

  const breadcrumbItems = useMemo(() => {
      let breadcrumbData =  [
        { label: 'Garden of Dreams Foundation', url: '/' },
        { label: 'Blog', url: '/blog' },
      ]
      if (!id) {
        return breadcrumbData;
      }
      if (id) {
        breadcrumbData.push({ label: storyArticle?.title || '', url: '' })
      }
      return breadcrumbData;
    
    }, [id, storyArticle]);
  
      useEffect(() => {
        /**
         * Appends the Breadcrumb component to the DOM
         */
        if (storyArticle && categoryBlockRef.current && !breadcrumbContainerRef.current.parentElement) {
          breadcrumbContainerRef.current.className = 'breadcrumb-wrapper';
          ReactDOM.render(<Breadcrumb items={breadcrumbItems} />, breadcrumbContainerRef.current);
          categoryBlockRef.current.insertAdjacentElement('beforebegin', breadcrumbContainerRef.current);
        }
        return () => {
          if (breadcrumbContainerRef.current && breadcrumbContainerRef.current.parentElement) {
            breadcrumbContainerRef.current.remove();
          }
        };
      }, [storyArticle, breadcrumbItems, id])

  const [realtedStories, setRelatedStories] = useState([])

  const fetchRelatedStories = useCallback(async () => {
    try {
      const res: any = await getTagList(storyArticle?.tags)
      if (!res?.error) {
        console.group(res)
        const filtered = res?.data?.article.filter(
          (item: any) => item?.uid !== storyArticle.uid
        );
        setRelatedStories(filtered);
        setStatus({ loading: false, error: null })
      } else {
        setStatus({ loading: false, error: 'Error fetching data' })
      }
    } catch (error: any) {
      if (error?.response?.data?.error?.status === 403) {
        const res: any = await getTagList(storyArticle?.tags, true)
        if (!res?.error) {
          const filtered = res?.data?.article.filter(
            (item: any) => item?.uid !== storyArticle.uid
          );
          setRelatedStories(filtered)
        }
      }
      setStatus({ loading: false, error: 'An error occurred while fetching data' })
    } finally {
      setStatus({ loading: false, error: null })
    }
  }, [storyArticle])

  const fetchArticle = useCallback(async () => {
    try {
      const res: any = await getArticleById(id)
      if (!res?.error) {
        setStoryArticle(res?.data)
        setStatus({ loading: false, error: null })
      } else {
        setStatus({ loading: false, error: 'Error fetching data' })
      }
    } catch (error: any) {
      if (error?.response?.data?.error?.status === 403) {
        const res: any = await getArticleById(id, true)
        if (!res?.error) {
          setStoryArticle(res?.data)
        }
      }
      setStatus({ loading: false, error: 'An error occurred while fetching data' })
    } finally {
      setStatus({ loading: false, error: null })
    }
  }, [id])

  useEffect(() => {
    fetchArticle()
  }, [id, fetchArticle])

  useEffect(() => {
    fetchRelatedStories()
  }, [storyArticle])

  if (status?.loading) {
    return <Loader />
  }

  if (status.error) {
    return <div>Error: {status.error}</div>
  }

  const handleBadgeClick = (tag: any) => {
    setSeletectedTag(tag)
  }

  const temp = menu?.find((item) => item?.category === 'blog')

  const blogUid = temp?.uid

  return (
    <div className='blog-details-container' ref={categoryBlockRef}>
      <div className='blog-details'>
        {/* <h2 className='blog-story-heading'>{storyArticle?.title}</h2> */}
        <h1 className='blog-story-heading'>{storyArticle?.title}</h1>
        {storyArticle?.content && <div className='spacer'></div>}
        <div className='story-banner'>
          {storyArticle?.heroBanner && (
            <section className='home'>
              <div id='carouselExampleCaptions' className='carousel slide'>
                <div className='carousel-inner'>
                  <div className='carousel-item active'>
                    <Image src={storyArticle?.heroBanner} className='d-block w-100' alt='banner' />
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
        <Helmet>
          <link rel='canonical' href={storyArticle?.canonical_url}></link>
          <title>{storyArticle?.meta_title}</title>
          <meta name='description' content={storyArticle?.meta_description} />
          <meta name='keywords' content={storyArticle?.meta_key} />
        </Helmet>
        {storyArticle?.content ? (
          <div dangerouslySetInnerHTML={getHtml(storyArticle?.content)} />
        ) : (
          <PageNotFound />  
        )}
      </div>

      <div className='see-all-stories'>
        <div className='left-section'>
          <div className='title'>All posts tagged:</div>
          <div className='badge-container'>
            {storyArticle?.tags
              ?.filter((i: any) => i !== 'carousel-item')
              ?.map((tag: any, idx: any) => {
                return (
                  <div
                    className={`stories-badge-wrapper `}
                    key={idx}
                    onClick={() => handleBadgeClick(tag)}
                  >
                    <div
                      className={`single-story-badge ${selectedTag === tag ? 'selected' : ''}`}
                      onClick={() => navigate(`/blog/tag/${encodeURIComponent(tag)}`)}
                    >
                      {tag}
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
        <div>
          <button onClick={() => navigate(`/content/${blogUid}`)} className={`view-load-more`}>
            SEE ALL STORIES
          </button>
        </div>
      </div>

      <div className='light-pink-bg'>
        <div className='category-container'>
          <h2 className='item-title'>Related Stories</h2>
          <div className='story-wrapper'>
            {realtedStories?.slice(0, 3)?.map((item: any, index: any) => {
              return (
                <div className='story' key={index}>
                  <Image src={item?.heroBanner} alt='story-banner' className='story__image' />
                  <h3 className='story__title'>
                    {item?.title.length > 60 ? item?.title.substring(0, 60) + '...' : item?.title}
                  </h3>
                  <CustomButton
                    title='Read More'
                    onClick={() => navigate(`/blog/${item?.uid}`)}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoryDetails
